export const syncDocumentLanguage = (language: string) => {
  document.documentElement.lang = language
}
